import { render, staticRenderFns } from "./u-btn-flat-rounded.vue?vue&type=template&id=e3db070c&scoped=true&"
import script from "./u-btn-flat-rounded.vue?vue&type=script&lang=js&"
export * from "./u-btn-flat-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3db070c",
  null
  
)

export default component.exports